module.exports = __webpack_public_path__ + "static/media/csv-preview.e230f1d8.jpg";